export function sorterToSql(params: { field: string; order: string }) {
  // 升序
  if (params.order === 'ascend') {
    return `${params.field}+`;
  }
  if (params.order === 'descend') {
    return `${params.field}-`;
  }
  return '';
}
